<template>
	<div data-test="asset-element-grid">
		<div :class="['asset-element-grid', { 'large-cards': props.useLargeCards }]">
			<AssetElementCardVertical
				v-for="assetElement in paginatedData"
				:key="`${assetElement.elementType}-${assetElement.fundriseId}`"
				:asset-element="assetElement"
			/>
		</div>
		<ListPaginator v-model:paginator="paginator" :enable-boundaries="true" @paginated="onPagination" />
	</div>
</template>
<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { Asset } from 'types/assets';
import AssetElementCardVertical from '@components/asset-element/asset-element-card-vertical.vue';
import ListPaginator from '@components/layout/list-paginator.vue';
import Paginator from '@classes/Paginator';

interface Props {
	assetElements: Array<Asset>;
	assetElementsPerPage?: number;
	useLargeCards?: boolean;
}

interface Emits {
	(e: 'paginated'): void;
}

const props = withDefaults(defineProps<Props>(), {
	assetElementsPerPage: 12,
	useLargeCards: false
});

const emits = defineEmits<Emits>();

const paginator = ref(new Paginator(0, props.assetElementsPerPage, props.assetElements.length));

const paginatedData = computed(
	(): Array<Asset> => props.assetElements.slice(paginator.value.start, paginator.value.end)
);

watch(
	() => props.assetElements,
	(): void => {
		paginator.value = new Paginator(0, props.assetElementsPerPage, props.assetElements.length);
	}
);

function onPagination(): void {
	emits('paginated');
}
</script>
<style lang="scss" scoped>
@use '../../styles/utilities/respond-to.scss' as *;

.asset-element-grid {
	display: flex;
	flex-direction: column;
	gap: 1rem;

	@include respond-to(md) {
		display: grid;
		gap: 1.5rem;
		grid-template-columns: repeat(3, 1fr);

		&.large-cards {
			grid-template-columns: repeat(3, 1fr);
		}
	}

	@include respond-to(lg) {
		display: grid;
		gap: 1.5rem;
		grid-template-columns: repeat(4, 1fr);
	}
}
</style>
